:host {
  --z-offcanvas--container-width: ;
  --z-offcanvas--container-height: ;
  --z-offcanvas--top-space: ;

  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host([variant="pushcontent"]:not([transitiondirection="up"])) {
  overflow: hidden;
}

.canvas-container {
  display: flex;
  overflow: hidden;
  min-width: 100%;
  height: 100%;
  background: var(--color-surface01);
  transition: transform 0.4s ease-out;
}

:host > * {
  position: fixed;
  top: var(--z-offcanvas--top-space, 0);
  right: 0;
  bottom: 0;
  left: 0;
}

:host([open]) > * {
  height: calc(100% - var(--z-offcanvas--top-space, 0px));
}

:host([transitiondirection="right"]) > .canvas-container {
  transform: translateX(-100%);
}

:host([transitiondirection="left"]) > .canvas-container {
  transform: translateX(100%);
}

:host([open][transitiondirection="right"]) > .canvas-container,
:host([open][transitiondirection="left"]) > .canvas-container {
  transform: translateX(0);
}

:host([transitiondirection="up"]) > .canvas-container {
  top: auto;
  bottom: 0;
  height: var(--z-offcanvas--container-height, 90%);
  transform: translateY(100%);
}

:host([transitiondirection="up"], [variant="overlay"]) > .canvas-container {
  z-index: 1001;
}

:host([open][transitiondirection="up"]) > .canvas-container {
  transform: translateY(0);
}

:host([variant="pushcontent"]:not([transitiondirection="up"])) > .canvas-container {
  position: relative;
  height: 100%;
}

:host([variant="pushcontent"]:not([open])) {
  display: none;
}

:host([skip-animation]) > .canvas-container {
  transition: none;
}

.canvas-background {
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: var(--gray900);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease-out;
}

:host([open]) > .canvas-background {
  opacity: 0.7;
  pointer-events: unset;
}

.canvas-container > .canvas-content {
  overflow: hidden auto;
  flex: 1 auto;
  padding: 0 calc(var(--space-unit) * 2);
  margin: calc(var(--space-unit) * 2) calc(var(--space-unit) / 2) calc(var(--space-unit) * 2) 0;
}

/* Webkit Scrollbar */
.canvas-container .canvas-content::-webkit-scrollbar {
  width: 6px;
  background: linear-gradient(to right, transparent 0 1px, var(--gray200) 1px 5px, transparent 5px 6px);
}

.canvas-container .canvas-content::-webkit-scrollbar-thumb {
  background-color: var(--color-primary01);
}

.canvas-container .canvas-content::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-hover-primary);
}

/* Firefox scrollbar */
@supports not selector(.canvas-content::-webkit-scrollbar-track) {
  .canvas-container .canvas-content {
    scrollbar-color: var(--color-primary01) transparent;
  }
}

/* Tablet / Desktop */
@media (min-width: 768px) {
  :host([variant="pushcontent"]:not([transitiondirection="up"])) {
    flex: none; /* Prevent unwanted width changes in flex containers */
  }

  .canvas-container {
    width: max(var(--z-offcanvas--container-width, 375px), 375px);
    min-width: 375px;
  }

  :host([transitiondirection="up"]) > .canvas-container {
    width: 100%;
  }

  :host([transitiondirection="right"]) > .canvas-container {
    right: auto;
    left: 0;
  }

  :host([transitiondirection="left"]) > .canvas-container {
    right: 0;
    left: auto;
  }
}
